import { useDispatch, useSelector } from "react-redux";
import Image from "../../../components/element/image";
import Col from "../../../components/element/col";
import Container from "../../../components/element/container";
import { Avatar } from "../../../assets/images";
import {
  openLoginModal,
  openProfileInfoModal,
  openReferralModal,
  openSavedCarsModal,
} from "../../../redux/reducer/modal.reducer";
import { useTranslation } from "react-i18next";
import Row from "../../../components/element/row";
import Icon from "../../../components/element/icon";
import Button from "../../../components/element/button";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import useRequireAuth from "../../../components/hook/use.require.auth";

export default function ProfileHeader() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isDesktop } = useWindowDimension();
  const { isAuthenticated, requireAuth } = useRequireAuth();
  const { token, username } = useSelector((state) => state.common);
  const { profileInfo } = useSelector((state) => state.profile);

  const handleOpenLogin = () => {
    requireAuth();
  };

  const tabList = [
    {
      title: "My Favorite",
      icon: "iconoir:bookmark",
      icon_width: isDesktop ? 32 : 28,
      icon_height: isDesktop ? 32 : 28,
      badge: profileInfo?.saved_cars_count ?? 0,
      onClick: () =>
        requireAuth(() => dispatch(openSavedCarsModal()), {
          modal: "savedCars",
        }),
    },
    {
      title: "My Referral",
      icon: "fluent:people-link-16-regular",
      icon_width: isDesktop ? 34 : 30,
      icon_height: isDesktop ? 34 : 30,
      onClick: () =>
        requireAuth(() => dispatch(openReferralModal()), {
          modal: "referral",
        }),
    },
    {
      title: "My Info",
      icon: "fluent:person-circle-16-regular",
      icon_width: isDesktop ? 36 : 32,
      icon_height: isDesktop ? 36 : 32,
      onClick: () => {
        requireAuth(() => dispatch(openProfileInfoModal()), {
          modal: "profileInfo",
        });
      },
    },
    {
      title: isAuthenticated ? "Log Out" : "Log In",
      icon: isAuthenticated ? "mynaui:logout-solid" : "mynaui:login-solid",
      icon_width: isDesktop ? 32 : 28,
      icon_height: isDesktop ? 32 : 28,
      onClick: () => {
        if (!isAuthenticated) {
          dispatch(openLoginModal());
          return;
        }

        localStorage.clear();
        window.location.reload();
      },
    },
  ];

  return (
    <Container className="profile-header">
      <Row className="profile-hero">
        <Col className="_col profile-hero-copy">
          <h1 className="_label hero-title">
            <span>{t("MY JOURNEY")}</span>
            <span className="gradient-text">{t("CONTINUES")}</span>
          </h1>
          <p className="_label hero-subtitle">
            {t("Manage your vehicles, consignments")}
            <br />
            {t("sell rewards \u2014 all in one place.")}
          </p>
        </Col>
      </Row>

      {!isDesktop && (
        <Row className="_row profile-info pointer" onClick={handleOpenLogin}>
          <Image src={Avatar} alt="" className="_img profile-avatar" />
          <Col className="_col profile-identity-copy gap-1 col-center">
            <h2 className="_label profile-title">
              <span>
                {token && username
                  ? `${t("Hello")} ${profileInfo?.name || profileInfo?.username || username}`
                  : t("Hello")}{" "}
              </span>
              <em className="profile-wave">{"\u{1F44B}"}</em>
            </h2>
            <p className="_label profile-subtitle pre">
              <span className="account-copy pre">
                {t(
                  token && username
                    ? "Manage your account"
                    : "Login view your profile",
                )}
              </span>
              <span className="welcome-copy">{t("Welcome back to DCAR!")}</span>
            </p>
          </Col>
        </Row>
      )}
      <Row className="profile-account">
        {isDesktop && (
          <Row className="_row profile-info pointer" onClick={handleOpenLogin}>
            <Image src={Avatar} alt="" className="_img profile-avatar" />
            <Col className="_col profile-identity-copy gap-2 col-center">
              <h2 className="_label profile-title">
                <span>
                  {token && username
                    ? `${t("Hello")} ${profileInfo?.name || profileInfo?.username || username}`
                    : t("Hello")}{" "}
                </span>
                <em className="profile-wave">{"\u{1F44B}"}</em>
              </h2>
              <p className="_label profile-subtitle pre">
                <span className="account-copy">
                  {t(
                    token && username
                      ? "Manage your account"
                      : "Login view your profile",
                  )}
                </span>
                <span className="welcome-copy">
                  {t("Welcome back to DCAR!")}
                </span>
              </p>
            </Col>
          </Row>
        )}
        <Row className="_row profile-tab w-100">
          <Row className="_row tab-list">
            {tabList.map((tab) => (
              <Button
                type="button"
                className={`_button tab-item`}
                //   ${
                //   tab.title === "My Info" && activeTab === "Overview"
                //     ? "active"
                //     : ""
                // }
                key={tab.title}
                onClick={tab.onClick}
              >
                <Col className="_col tab-icon">
                  <Icon
                    icon={tab.icon}
                    width={tab.icon_width}
                    height={tab.icon_height}
                    className="_svg tab-icon"
                  />
                  {tab.badge !== undefined && Number(tab.badge) > 0 && (
                    <span className="_label tab-badge">{tab.badge}</span>
                  )}
                </Col>
                <span className="_label tab-title">{t(tab.title)}</span>
              </Button>
            ))}
          </Row>
        </Row>
      </Row>
    </Container>
  );
}
